"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffTime = void 0;
function diffTime(a, b) {
    return Math.abs(new Date(a).getTime() - new Date(b).getTime());
}
exports.diffTime = diffTime;
